import React, { Component } from "react";

class SocialShare extends Component {
  state = {
    showPopup: false,
  };

  togglePopup = () => {
    this.setState({ showPopup: !this.state.showPopup });
  };

  render() {
    const { url, title } = this.props; // URL and Title to share
    const encodedUrl = encodeURIComponent(url);
    const encodedTitle = encodeURIComponent(title);

    const socialLinks = [
      {
        name: "Facebook",
        url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        icon: "🔵",
      },
      {
        name: "Twitter (X)",
        url: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
        icon: "🐦",
      },
      {
        name: "LinkedIn",
        url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}`,
        icon: "🔗",
      },
      {
        name: "WhatsApp",
        url: `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`,
        icon: "🟢",
      },
    ];

    return (
      <div>
        {/* <button onClick={this.togglePopup} className="share-btn">
          Share
        </button> */}

     
          <div className="popup-overlay">
            <div className="popup-content">
              <h3>Share this page</h3>
              <ul>
                {socialLinks.map((platform) => (
                  <li key={platform.name}>
                    <a href={platform.url} target="_blank" rel="noopener noreferrer">
                      {platform.icon} {platform.name}
                    </a>
                  </li>
                ))}
              </ul>
              <button onClick={this.togglePopup} className="close-btn">Close</button>
            </div>
          </div>
        

        <style>
          {`
            .share-btn {
              padding: 10px 15px;
              background: #007bff;
              color: white;
              border: none;
              cursor: pointer;
              border-radius: 5px;
            }
           
            .popup-content {
              background: white;
              padding: 20px;
              border-radius: 10px;
              text-align: center;
            }
            .popup-content ul {
              list-style: none;
              padding: 0;
            }
            .popup-content li {
              margin: 10px 0;
            }
            .popup-content a {
              text-decoration: none;
              font-weight: bold;
            }
            .close-btn {
              margin-top: 15px;
              padding: 5px 10px;
              background: red;
              color: white;
              border: none;
              cursor: pointer;
              border-radius: 5px;
            }
          `}
        </style>
      </div>
    );
  }
}

export default SocialShare;
